import { DateTime } from 'luxon'
import { Action, Reducer } from 'redux'
import { LogMessageDTO } from '../generated/ApiClient'

export interface WebSocketState {
    messages: [string, LogMessageDTO][]
}

interface ReceiveDiagnosticAction {
    type: 'sockets/ReceiveMessage'
    time: DateTime
    message: LogMessageDTO
}

interface ReceiveErrorAction {
    type: 'sockets/ReceiveError'
    message: string
}

type WebSocketAction = ReceiveDiagnosticAction | ReceiveErrorAction

export const actionCreators = {
    receiveMessage: (message: LogMessageDTO): WebSocketAction => ({ type: 'sockets/ReceiveMessage', time: DateTime.local(), message }),
    receiveError: (message: string): WebSocketAction => ({ type: 'sockets/ReceiveError', message })
}

const unloadedState = { messages: [] }

export const reducer: Reducer<WebSocketState> = (state: WebSocketState | undefined, incomingAction: Action): WebSocketState => {
    if (state === undefined)
        return unloadedState

    const action = incomingAction as WebSocketAction
    switch (action.type) {
        case 'sockets/ReceiveMessage':
            const fiveMinutesAgo = action.time.minus({ minutes: 5 })
            return {
                messages: [
                    [action.time.toISO(), action.message],
                    ...state.messages.filter(([date, _]) => DateTime.fromISO(date) > fiveMinutesAgo)
                ]
            }
        default:
            return state
    }
}